document.addEventListener('submit', (event) => {
	const button = event.submitter;
	if (!event.target.closest('product-form') || !button?.classList.contains('atc-button') ||
		button.disabled || button.getAttribute('aria-busy') === 'true') return;

	// Prestige marks every submit button busy; show the spinner only on the one pressed.
	for (const control of event.target.elements) {
		if (control.classList.contains('atc-button')) {
			control.toggleAttribute('data-atc-submitter', control === button);
		}
	}
}, { capture: true });
